/* eslint-disable no-undef */
// These are custom defined turbo stream actions

Turbo.StreamActions.scrollToTop = function () {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

Turbo.StreamActions.toggleClass = function () {
  const className = this.templateContent.textContent.trim();

  this.targetElements.forEach((target) => {
    target.classList.toggle(className);
  });
};

Turbo.StreamActions.addClass = function () {
  const className = this.templateContent.textContent.trim();

  this.targetElements.forEach((target) => {
    target.classList.add(className);
  });
};

Turbo.StreamActions.removeClass = function () {
  const className = this.templateContent.textContent.trim();

  this.targetElements.forEach((target) => {
    target.classList.remove(className);
  });
};

Turbo.StreamActions.updateDataAttribute = function () {
  const content = this.templateContent.textContent.trim();
  const [attributeName, attributeValue] = content.split(':');

  this.targetElements.forEach((target) => {
    target.setAttribute(`data-${attributeName}`, attributeValue);
  });
};

Turbo.StreamActions.clickTarget = function () {
  target = document.querySelector(this.target)
  target.click();
};

Turbo.StreamActions.redirectTo = function () {
  const url = this.templateContent.textContent.trim();
  window.location.href = url;
};
